module.exports = __webpack_public_path__ + "static/media/bgame-mobile.2ac0648b.svg";